<template>
  <v-card class="mx-auto" :disabled="loading" :loading="loading">
    <v-card-title>
      ตั้งค่ารายละเอียดค่าธรรมเนียมการศึกษา ระดับบัณฑิตศึกษา
    </v-card-title>
    <v-card-text>
      ระบบคำนวณค่าเทอมของ นศ. จะดูจากการตั้งค่าหน้านี้ว่าใน หลักสูตร
      ประเภทรับเข้า ปีการศึกษาที่รับเข้า และ นศ.ไทย/ต่างชาติ (ยังไม่ลงลึกถึงแผน)
      ว่ามีการตั้งค่าไว้สัก 1 แผนไหม หากมีตั้คค่าไว้สัก 1 แผน
      (ไม่สนว่าเป็นแผนไหน) จะใช้การตั้งค่านั้นเลย 
      <span style="color: orange;">
        หากมีการตั้งค่าไว้มากกว่า 1 แผน ระบบจะหาการตั้งค่าที่ตรงกับแผนของ นศ.
        แต่ถ้าหากหาไม่เจอจะใช้การตั้งค่าที่ "ไม่คิดแบบ/แผน"
      </span>
      <StudentInfo/>
    </v-card-text>
    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>
            {{ level.LEVEL_NAME_EN }}
          </h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <v-form v-model="form_validate_status" ref="form">
                <v-row>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="selected_faculty_id"
                      :items="faculties"
                      :item-value="(item) => item.faculty_id"
                      :item-text="(item) => item.faculty_name_th"
                      outlined
                      dense
                      label="คณะ"
                      hide-details
                      :rules="required"
                      @change="update_faculty()"
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-autocomplete
                      v-model="selected_curriculum_id"
                      :items="filter_curriculums"
                      :item-value="(item) => item.curriculum_id"
                      :item-text="
                        (item) =>
                          'currID: ' +
                          item.curriculum_id +
                          ' ' +
                          item.curriculum_name_th +
                          ' (' +
                          item.year +
                          ')'
                      "
                      outlined
                      dense
                      label="หลักสูตร"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                      clearable
                      placeholder="แนะนำให้พิมพ์ชื่อหลักสูตรแบบสั้น เพื่อกรองข้อมูล (และกรณีมีชื่อซ้ำ)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="selected_year"
                      :items="years"
                      outlined
                      dense
                      label="ปีการศึกษาที่รับเข้า"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                    />
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-autocomplete
                      v-model="selected_semester"
                      :items="semesters"
                      outlined
                      dense
                      label="เทอมที่รับเข้า"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="selected_admis_type_id"
                      :items="study_admit_types"
                      :item-value="(item) => item.REGISTRAR_ADMIT_TYPE_ID"
                      :item-text="(item) => item.STUDY_ADMIT_TYPE_NAME_TH"
                      outlined
                      dense
                      label="ประเภทการรับเข้า"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="selected_thai_or_foreign"
                      :items="thai_or_foreign"
                      :item-value="(item) => item.value"
                      :item-text="(item) => item.text"
                      outlined
                      dense
                      label="ค่าธรรมเนียมสำหรับนักศึกษา"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-autocomplete
                      v-model="selected_prog_id"
                      :items="filter_study_plans"
                      :item-value="(item) => item.REGISTRAR_PROGRAM_ID"
                      :item-text="(item) => item.study_plan_name"
                      outlined
                      dense
                      label="แผนการศึกษา"
                      hide-details
                      :rules="required"
                      @change="fetch_data()"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <spam v-if="!form_validate_status"
                      >เลือกเงื่อนไขให้ครบหากต้องการ "เพิ่มข้อมูล" ใหม่</spam
                    >
                    <v-btn
                      color="success"
                      @click="
                        $refs.addEditDialog.open_add_modal(
                          selected_level,
                          selected_faculty_id,
                          selected_curriculum_id,
                          selected_year,
                          selected_semester,
                          selected_admis_type_id,
                          selected_thai_or_foreign,
                          selected_prog_id,
                          name_faculty,
                          name_curriculum,
                          name_admis_type,
                          name_thai_or_foreign,
                          name_study_plan
                        )
                      "
                      v-if="form_validate_status"
                    >
                      <v-icon>mdi-plus</v-icon>เพิ่มข้อมูล
                    </v-btn></v-col
                  >
                </v-row>
              </v-form>

              <v-simple-table
                min-height="300px"
                class="mt-3 text-no-wrap text-center"
              >
                <thead class="blue-grey darken-1">
                  <tr>
                    <th class="white--text text-center font-weight-regular">
                      แก้ไข/ลบ
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      #
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ปี/เทอม ที่รับเข้าศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ประเภทรับเข้า
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      สำหรับนักศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      คิดเงินตามแผนการเรียน
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ค่าเทอมเหมาจ่าย
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ค่ารักษาสภาพนักศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ค่าลาพักการศึกษา
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      ค่าเทอม Summer
                    </th>
                    <th class="white--text text-center font-weight-regular">
                      วันที่บันทึก [ผู้บันทึก]
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="data.length === 0">
                    <td colspan="11">
                      <p class="text-center text-secondary mb-0">no result</p>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in data" :key="index">
                    <td>
                      <v-btn
                        small
                        color="warning"
                        v-on:click="
                          $refs.addEditDialog.open_edit_modal(
                            selected_level,
                            selected_faculty_id,
                            selected_curriculum_id,
                            selected_year,
                            selected_semester,
                            selected_admis_type_id,
                            selected_thai_or_foreign,
                            selected_prog_id,
                            name_faculty,
                            name_curriculum,
                            name_admis_type,
                            name_thai_or_foreign,
                            name_study_plan,
                            item
                          )
                        "
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        class="ml-2"
                        small
                        color="error"
                        @click="
                          $refs.deleteDialog.open_delete_modal(
                            selected_level,
                            selected_faculty_id,
                            selected_curriculum_id,
                            selected_year,
                            selected_semester,
                            selected_admis_type_id,
                            selected_thai_or_foreign,
                            selected_prog_id,
                            name_faculty,
                            name_curriculum,
                            name_admis_type,
                            name_thai_or_foreign,
                            name_study_plan,
                            item
                          )
                        "
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.admis_term }}/{{ item.admis_year }}</td>
                    <td>
                      {{ get_study_admit_type_by_id(item.admis_type) }}
                    </td>
                    <td>
                      <span
                        :style="{
                          color: item.inter_student == '1' ? 'blue' : '',
                        }"
                      >
                        {{
                          item.inter_student === "0"
                            ? "นักศึกษาไทย"
                            : "นักศึกษาต่างชาติ"
                        }}
                      </span>
                    </td>
                    <td style="text-align: left">
                      {{ item.study_plan_name }}
                    </td>
                    <td>
                      <span
                        :style="{
                          color: item.package_fee == '0' ? 'red' : 'black',
                          fontWeight: 'bold',
                        }"
                      >
                        {{ numberWithCommas(item.package_fee) }}
                      </span>
                    </td>
                    <td>
                      <span
                        :style="{
                          color: item.maintain_fee == '0' ? 'red' : 'black',
                          fontWeight: 'bold',
                        }"
                      >
                        {{ numberWithCommas(item.maintain_fee) }}
                      </span>
                    </td>
                    <td>
                      <span
                        :style="{
                          color: item.leave_fee == '0' ? 'red' : 'black',
                          fontWeight: 'bold',
                        }"
                      >
                        {{ numberWithCommas(item.leave_fee) }}
                      </span>
                    </td>
                    <td>
                      <span
                        :style="{
                          color: item.summer_fee == '0' ? 'red' : 'black',
                          fontWeight: 'bold',
                        }"
                      >
                        {{ numberWithCommas(item.summer_fee) }}
                      </span>
                    </td>
                    <td>{{ dt(item.timestamp) }} [{{ item.operator }}]</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <ConfigGraduateCurriculumFeeAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
    />

    <ConfigGraduateCurriculumFeeDeleteDialog
      ref="deleteDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
    />
  </v-card>
</template>

<script>
import dayjs from "dayjs";
import { numberWithCommas } from "@/helper/format";
import ConfigGraduateCurriculumFeeAddEditDialog from "./components/ConfigGraduateCurriculumFeeAddEditDialog";
import ConfigGraduateCurriculumFeeDeleteDialog from "./components/ConfigGraduateCurriculumFeeDeleteDialog";
import { dateTimeFromDBTranslatorFull as dt } from "@/helper/translator";
import ConfigProvider from "@/services/config.provider";
import GenericProvider from "@/services/generic.provider";
import RefProvider from "@/services/ref.provider";
import StudentInfo from "@/views/user/StudentInfo.vue";

const semesters = ["1", "2"];
const configService = new ConfigProvider();
const genericService = new GenericProvider();
const refService = new RefProvider();

export default {
  name: "ConfigGraduateCurriculumFee",
  data: () => ({
    loading: false,
    level_tab: 2,

    levels: [
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "ปริญญาโท",
        LEVEL_NAME_TH: "ปริญญาโท",
      },
      {
        LEVEL_ID: "3",
        LEVEL_NAME_EN: "ปริญญาเอก",
      },
    ],
    faculties: [],
    curriculums: [],
    study_plans: [],
    filter_study_plans: [],
    study_admit_types: [],

    years: [],
    semesters: semesters,
    thai_or_foreign: [
      { text: "นักศึกษาไทย", value: "0" },
      { text: "นักศึกษาต่างชาติ", value: "1" },
    ],

    selected_faculty_id: null,
    selected_curriculum_id: null,
    selected_admis_type_id: null,
    selected_year: null,
    selected_semester: "1",
    selected_prog_id: null, //คือค่า REGISTRAR_PROGRAM_ID ในตาราง master_reg_curriculum.STUDY_PLAN หรือก็คือ prog_id ใน registrar.x_student
    selected_thai_or_foreign: null,

    required: [(v) => !!v || "Required"],

    form_validate_status: false,

    data: [],
  }),
  components: {
    ConfigGraduateCurriculumFeeAddEditDialog,
    ConfigGraduateCurriculumFeeDeleteDialog,
    StudentInfo,
  },

  methods: {
    dt,
    numberWithCommas,
    async get_all_faculties() {
      const response = await genericService
        .getRegistrarFaculty()
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      if (response) this.faculties = response;
    },

    async get_all_curriculum(val) {
      const response = await genericService
        .getRegistrarCurriculum(parseInt(val))
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      if (response) this.curriculums = response;
    },

    get_years() {
      const maxYear = parseInt(dayjs().format("BBBB")) + 2;
      for (let year = 2550; year <= maxYear; year++) this.years.push(year);
      this.years.sort().reverse();
    },

    async get_all_study_plan() {
      const response = await refService.getStudyPlan().catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
      });

      if (response) {
        let default_study_plan = {
          REGISTRAR_PROGRAM_ID: "0",
          study_plan_name: "ไม่คิดแบบ/แผน",
          STUDY_PLAN_NAME_TH_BELOW_2566: "ไม่คิดแบบ/แผน",
          STUDY_PLAN_NAME_TH: "ไม่คิดแบบ/แผน",
        };
        this.study_plans = response;
        this.filter_study_plans = this.study_plans.filter(
          (item) =>
            item.LEVEL_ID === this.selected_level &&
            item.REGISTRAR_SUB_PROGRAM_ID == 0
        );
        this.filter_study_plans.map((item) => {
          item.study_plan_name = item.STUDY_PLAN_NAME_TH;
        });
        this.filter_study_plans.unshift(default_study_plan);
      }
    },

    async get_study_admit_type() {
      const response = await refService
        .getStudyAdmitTypeByLevel(2)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
        });

      if (response) this.study_admit_types = response;
    },

    get_study_admit_type_by_id(id) {
      const admitType = this.study_admit_types.find(
        (item) => item.REGISTRAR_ADMIT_TYPE_ID == id
      );
      return admitType ? admitType.STUDY_ADMIT_TYPE_NAME_TH : null;
    },

    update_faculty() {
      this.data = [];
      this.selected_curriculum_id = null;
      this.curriculums = this.curriculums.filter(
        (item) => item.LEVEL_ID === this.level_id_fake
      );
    },

    update_student_plan_by_year() {
      this.filter_study_plans.map((item) => {
        item.study_plan_name =
          this.selected_year <= 2566
            ? item.STUDY_PLAN_NAME_TH_BELOW_2566
            : item.STUDY_PLAN_NAME_TH;
      });
    },

    async fetch_data() {
      this.loading = true;
      this.data = [];
      if (
        this.selected_curriculum_id &&
        this.selected_year &&
        this.selected_semester
      ) {
        let response = await configService
          .getGraduateCurriculumFee({
            curr_id: this.selected_curriculum_id,
            admis_year: this.selected_year,
            admis_term: this.selected_semester,
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.loading = false;
          });

        if (response) {
          if (this.selected_admis_type_id) {
            response = response.filter(
              (item) => item.admis_type === this.selected_admis_type_id
            );
          }
          if (this.selected_prog_id) {
            response = response.filter(
              (item) => item.prog_id === this.selected_prog_id
            );
          }
          if (this.selected_thai_or_foreign) {
            response = response.filter(
              (item) => item.inter_student === this.selected_thai_or_foreign
            );
          }
          this.data = response.map((item_data) => {
            if (item_data["prog_id"] == "0") {
              item_data.study_plan_name = "ไม่คิดแบบ/แผน";
            } else {
              let ref_data = this.study_plans.find(
                (item) => item["REGISTRAR_PROGRAM_ID"] == item_data["prog_id"]
              );
              item_data.study_plan_name =
                ref_data && this.selected_year <= 2566
                  ? ref_data.STUDY_PLAN_NAME_TH_BELOW_2566
                  : ref_data
                  ? ref_data.STUDY_PLAN_NAME_TH
                  : "Unknown Study Plan";
            }
            // map ค่า admis_type เพื่อเอาชื่อภาษาไทยมาแปะเป้นข้อมูลเเพิ่ม
            let ref_data = this.study_admit_types.find(
              (item) =>
                item["REGISTRAR_ADMIT_TYPE_ID"] == item_data["admis_type"]
            );
            item_data.admis_type_name = ref_data
              ? ref_data.STUDY_ADMIT_TYPE_NAME_TH
              : "Unknown Study Admit Type";

            return item_data;
          });
        }
      }

      this.loading = false;
    },

    toggle_loading(status) {
      this.loading = status;
    },
  },

  computed: {
    filter_curriculums() {
      let data = [];
      if (this.selected_faculty_id) {
        data = this.curriculums.filter(
          (item) => item.faculty_id === this.selected_faculty_id
        );
      }
      return data;
    },
    selected_level() {
      return this.levels[this.level_tab].LEVEL_ID;
    },
    name_faculty() {
      return this.faculties.find(
        (item) => item.faculty_id === this.selected_faculty_id
      )?.faculty_name_th;
    },
    name_curriculum() {
      return this.curriculums.find(
        (item) => item.curriculum_id === this.selected_curriculum_id
      )?.curriculum_name_th;
    },
    name_admis_type() {
      return this.study_admit_types.find(
        (item) => item.REGISTRAR_ADMIT_TYPE_ID === this.selected_admis_type_id
      )?.STUDY_ADMIT_TYPE_NAME_TH;
    },
    name_thai_or_foreign() {
      return this.thai_or_foreign.find(
        (item) => item.value === this.selected_thai_or_foreign
      )?.text;
    },
    name_study_plan() {
      if (this.selected_prog_id === "0") {
        return "ไม่คิดแบบ/แผน";
      } else {
        if (this.selected_year <= 2566) {
          return this.study_plans.find(
            (item) => item.REGISTRAR_PROGRAM_ID === this.selected_prog_id
          )?.STUDY_PLAN_NAME_TH_BELOW_2566;
        } else {
          return this.study_plans.find(
            (item) => item.REGISTRAR_PROGRAM_ID === this.selected_prog_id
          )?.STUDY_PLAN_NAME_TH;
        }
      }
    },
  },

  watch: {
    level_tab(newVal) {
      this.data = [];
      this.selected_level = this.levels[newVal].LEVEL_ID;
      this.get_all_curriculum(this.selected_level);
      this.filter_study_plans = this.study_plans.filter(
        (item) =>
          item.LEVEL_ID == this.selected_level &&
          item.REGISTRAR_SUB_PROGRAM_ID == 0
      );
      let default_study_plan = {
        REGISTRAR_PROGRAM_ID: "0",
        study_plan_name: "ไม่คิดแบบ/แผน",
        STUDY_PLAN_NAME_TH_BELOW_2566: "ไม่คิดแบบ/แผน",
        STUDY_PLAN_NAME_TH: "ไม่คิดแบบ/แผน",
      };
      this.filter_study_plans.unshift(default_study_plan);
      this.update_student_plan_by_year();
    },
    selected_year() {
      this.update_student_plan_by_year();
    },
  },

  created() {
    this.get_all_faculties();
    this.get_all_curriculum(2);
    this.get_years();
    this.get_all_study_plan();
    this.get_study_admit_type();
  },
};
</script>

<style>
th {
  letter-spacing: 1px;
}
.last-cell {
  border-right-width: 1px;
}
</style>
